import { useEffect, useState } from 'react';

// Keep the existing floating control available, then dock the same instance in
// its reserved footer space when that space is fully visible.
export default function useFooterDock(id, pathname) {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    setTarget(null);
    const slot = document.getElementById(id);
    if (!slot || !window.IntersectionObserver) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      setTarget(entry.isIntersecting && entry.intersectionRatio >= 0.99 ? slot : null);
    }, { threshold: [0, 0.99, 1] });
    observer.observe(slot);
    return () => observer.disconnect();
  }, [id, pathname]);

  return target?.isConnected ? target : null;
}
